import type { ReactNode } from 'react';

export type EditCellOverlayPosition = 'above' | 'below' | 'anchored';

export interface EditCellOverlayProps {
  children: ReactNode;
  position?: EditCellOverlayPosition;
}

const cardClassName =
  'bg-white rounded-lg shadow-xl border-2 border-prim p-3 min-w-[200px]';

const positionClassName: Record<EditCellOverlayPosition, string> = {
  above: 'absolute bottom-full left-0 z-50',
  below: 'absolute top-full left-0 z-50',
  anchored: '',
};

export function EditCellOverlay({
  children,
  position = 'above',
}: Readonly<EditCellOverlayProps>) {
  return (
    <div className={`${positionClassName[position]} ${cardClassName}`.trim()}>
      {children}
    </div>
  );
}
